module.exports = "<ul style=\"margin: 0 1em\" class=list-unstyled><li v-for=\"item in fdata.content | blanks\"><a :href=\"item | link\" target=_blank download=download class=link><span class=link__icon><i class=\"fa fa-file-text-o\"> </i></span><span class=link__text>{{ item.title }}</span></a></li></ul>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/file/assets.vue
// module id = 445
// module chunks = 0